import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getLabTests = (params?: any) => {
  return api.get(`${BASE_URL}/api/v1/lab-tests`,{params});
};

export const getLabOrderById = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/lab-orders/${id}`);
};

export const createLabOrder = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/lab-orders`, payload);
};

export const updateLabOrder = (id: number, payload: any) => {
  return api.put(`${BASE_URL}/api/v1/lab-orders/${id}`, payload);
};
export const getLabOrders = (params?: any) => {
  return api.get(`${BASE_URL}/api/v1/lab-orders`,{params});
};

// Lab Test APIs
export const saveLabTest = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/lab-tests`, camelToSnake(payload));
};

export const updateLabTest = (id: number, payload: any) => {
  return api.put(`${BASE_URL}/api/v1/lab-tests/${id}`, camelToSnake(payload));
};

export const getLabTestById = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/lab-tests/${id}`);
};

export const getLabTestCategories = (params?: any) => {
  return api.get(`${BASE_URL}/api/v1/lab-test-categories`,{params});
};

export const createLabTestCategory = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/lab-test-categories`, camelToSnake(payload));
};

export const getLabTestCategoryById = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/lab-test-categories/${id}`);
};

export const updateLabTestCategory = (id: number, payload: any) => {
  return api.put(`${BASE_URL}/api/v1/lab-test-categories/${id}`,camelToSnake(payload));
};

export const updateLabOrderStatus = (id: number, status: string) => {
  return api.patch(`${BASE_URL}/api/v1/lab-orders/${id}/status`, { status });
};

export const updateResults = (id: number, payload: any) => {
  return api.put(`${BASE_URL}/api/v1/lab-orders/${id}/results`, payload);
};
